import $ from 'jquery';
import Glide, { Autoplay, Breakpoints, Controls, Images, Keyboard, Swipe } from '@glidejs/glide/dist/glide.modular.esm';

function init() {
    const carouselElm = $('.carousel');

    if (!carouselElm.length){
        return;
    }

    carouselElm.each((index, elm) => {
        const options = Object.assign({
            type: 'carousel',
            gap: 0,
            classes: {
                direction: {
                    ltr: 'carousel-ltr',
                    rtl: 'carousel-rtl'
                },
                slider: 'is-slider',
                carousel: 'is-carousel',
                swipeable: 'is-swipeable',
                dragging: 'is-dragging',
                cloneSlide: 'is-clone',
                activeNav: 'is-active',
                activeSlide: 'is-active',
                disabledArrow: 'is-disabled'
            },
            breakpoints: {
                768: {
                    perView: 1
                }
            }
        }, $(elm).data('carousel-opt'));

        const carousel = new Glide(elm, options);
        carousel.mount({ Autoplay, Breakpoints, Controls, Images, Keyboard, Swipe });
    });
}

export default {
    init
};
